import React, { memo, useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { useQuery } from '@apollo/client';
import { unwrap } from 'api/schema/utils';
import GET_ORDERS from 'api/queries/GET_ORDERS';
import BriefList from 'components/common/BriefList';
import Loader from 'common/Loader';
import Scrollable from 'common/Scrollable';
import ThemedButton from 'common/ThemedButton';
import TextPlaceholder from 'components/common/TextPlaceholder/TextPlaceholder';
import { Add as AddIcon } from '@material-ui/icons';
import OrderFilters from './OrderFilters';
import OrderListingMenu from './OrderListingMenu/OrderListingMenu';
import useOrders from './useOrders';
const OrdersList = () => {
    var _a, _b;
    const { t } = useTranslation(['common', 'orders']);
    const handlers = useOrders();
    const [search, setSearch] = useState('');
    const [statuses, setStatuses] = useState(['DRAFT', 'APPROVED']);
    const { data, loading } = useQuery(GET_ORDERS, {
        variables: {
            orderBy: '-modifiedDate',
            statuses,
        },
        fetchPolicy: 'network-only',
    });
    const orders = (_b = unwrap((_a = data === null || data === void 0 ? void 0 : data.me) === null || _a === void 0 ? void 0 : _a.orders)) === null || _b === void 0 ? void 0 : _b.filter((order) => order.orderId.indexOf(search) >= 0);
    const addOrder = useCallback(() => {
        handlers.addOrder();
    }, [handlers]);
    const getModelSpecificationURL = (model) => `/specifications/details/${model.modelSpecificationNode.id}/summary`;
    return (React.createElement("div", { className: "fa-module" },
        React.createElement(OrderFilters, { onSearch: setSearch, statuses: statuses, onChangeStatuses: setStatuses }),
        loading ? (React.createElement(Loader, { size: 40 })) : (React.createElement(React.Fragment, null,
            React.createElement(Scrollable, { className: "module-table custom-table" },
                React.createElement("table", null,
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", null, t('orders:number')),
                            React.createElement("th", null, t('orders:corrects')),
                            React.createElement("th", null, t('orders:specifications')),
                            React.createElement("th", null, t('orders:volume_total')),
                            React.createElement("th", null, t('orders:suppliers')),
                            React.createElement("th", null, t('orders:status')),
                            React.createElement("th", null, t('created_date')),
                            React.createElement("th", null, t('modified_date')))),
                    React.createElement("tbody", null, orders === null || orders === void 0 ? void 0 : orders.map((order) => (React.createElement("tr", { key: order.id },
                        React.createElement("td", null,
                            React.createElement(OrderListingMenu, { order: order })),
                        order.correctedOrder === null ? (React.createElement("td", null,
                            " ",
                            t(`orders:correction_none`),
                            " ")) : (React.createElement("td", null,
                            React.createElement(OrderListingMenu, { order: order.correctedOrder }))),
                        React.createElement("td", null,
                            React.createElement(BriefList, { count: 1, data: unwrap(order.models) || [], keyFn: (model) => model.modelSpecificationNode.id, itemRenderer: (model) => (React.createElement(Link, { to: getModelSpecificationURL(model) }, `${model.modelSpecificationNode.itemCode}`)), header: t('orders:specifications'), placeholder: t('orders:specifications_none') })),
                        React.createElement("td", null, order.sumOfModelQuantities),
                        React.createElement("td", null,
                            React.createElement(BriefList, { count: 5, data: order.orderSuppliers.edges || [], keyFn: (edge) => { var _a; return ((_a = edge === null || edge === void 0 ? void 0 : edge.node) === null || _a === void 0 ? void 0 : _a.supplier.id) || ''; }, itemRenderer: (edge) => { var _a; return React.createElement("span", null, (_a = edge === null || edge === void 0 ? void 0 : edge.node) === null || _a === void 0 ? void 0 : _a.supplier.shortName); }, header: t('orders:suppliers'), placeholder: t('orders:suppliers_none') })),
                        React.createElement("td", null, t(`orders:status.${order.status}`)),
                        React.createElement("td", null, moment(order.createdDate).format('DD.MM.YYYY')),
                        React.createElement("td", null, moment(order.modifiedDate).format('DD.MM.YYYY'))))))),
                (orders === null || orders === void 0 ? void 0 : orders.length) === 0 && (React.createElement(TextPlaceholder, { message: t('orders:order_list_placeholder') }))),
            React.createElement(ThemedButton, { icon: React.createElement(AddIcon, null), onClick: addOrder, className: "module-list-add" }, t('orders:add_order'))))));
};
export default memo(OrdersList);
